import React from 'react';
import {
  ABOUT,
  BUSINESS,
  BUSINESSES,
  EXPERIENCE,
  FAVORITE_PLANS,
  PLANS,
  USER_HISTORIES,
} from '../../routing';
import T from 'i18n-react';
import StarOutlineRoundedIcon from '@material-ui/icons/StarOutlineRounded';
import HistoriesImage from '../../../../images/user/history.png';
import { LinkProps } from '@material-ui/core/Link';

export const TOOLBAR_SM_MIN_HEIGHT = 52;
const SUBHEADER_MIN_HEIGHT = 60;
export const HEADER_MIN_HEIGHT = 64 + SUBHEADER_MIN_HEIGHT;

export const getMenus = (): {
  ['about' | 'plans' | 'businesses' | 'diary' | 'business']: LinkProps,
} => ({
  about: { href: ABOUT, children: T.translate('header.about') },
  plans: { href: PLANS, children: T.translate('header.plans') },
  businesses: { href: BUSINESSES, children: T.translate('header.businesses') },
  diary: { href: EXPERIENCE, children: T.translate('header.diary') },
  business: {
    href: BUSINESS,
    children: T.translate('header.business'),
    id: 'business_gnavi',
    target: '_blank',
  },
});

// Menus positioned on Header and Account Menu by the device size
export const getDynamicMenus = (): Array<{
  href: string,
  src?: string,
  icon: React.ComponentType,
  text: React.ReactNode,
}> => [
  {
    href: FAVORITE_PLANS,
    icon: StarOutlineRoundedIcon,
    text: T.translate('menu.favorite'),
  },
  {
    href: USER_HISTORIES,
    src: HistoriesImage,
    text: T.translate('menu.histories'),
  },
];

export const getMinHeight = (theme) =>
  theme.mixins.toolbar.minHeight + theme.spacing(1);

export const getLinkStyles = (
  theme,
  {
    underline = false,
    color,
    hoverColor = color,
  }: { underline?: boolean, color?: string, hoverColor?: string } = {},
) => ({
  color: `${color} !important`,
  fontSize: theme.typography.pxToRem(15),
  backgroundColor: 'transparent',
  '&:hover': {
    color: `${hoverColor} !important`,
    backgroundColor: 'transparent',
    ...(!underline && { textDecoration: 'none' }),
  },
  '&:focus': {
    backgroundColor: 'transparent',
  },
});
